import { useMobileAppListeners } from 'hooks/mobileAppListeners/useMobileAppListeners';

export const useOn3DSStatusUpdates = () => {
  const fireListeners = useMobileAppListeners();

  const on3DSstatusUpdatesFn = threeDsStatusEvent => {
    if (!!window.appInterface || !!window.webkit) {
      fireListeners(threeDsStatusEvent);
      return;
    }
  };

  return on3DSstatusUpdatesFn;
};
